import Dialog from "rc-dialog";
import * as React from "react";
import i18n from "Translations/i18n";

import "rc-dialog/assets/index.css";
import styles from "./DeleteModal.scss";

interface IProps {
    visible: boolean;
    onDelete: () => void;
    onCancel: () => void;
    message: string;
}

const DeleteModal: React.FunctionComponent<IProps> = (props: IProps) => {
    return (
        <Dialog className={styles.deleteDialog} visible={props.visible} closable={true} onClose={props.onCancel}>
            <div>
                <h6>{i18n.t("common.delete")}</h6>
                <p>{props.message}</p>
                <div className={styles.buttons}>
                    <button id="btnDelete" onClick={props.onDelete} className={styles.warning}>{i18n.t("common.delete")}</button>
                    <button id="btnCancel" onClick={props.onCancel}>{i18n.t("common.cancel")}</button>
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteModal;


// WEBPACK FOOTER //
// ./src/Components/DeleteModal/DeleteModal.tsx